/**
 * CO-SUPERVISION — supervisors who cover for each other.
 *
 * Michael, 2026-09-30: "Cody and Grayson have got to be able to see each others'
 * employees in WLX to approve for each other. They should be THE exception to the rule
 * where supervisors should only see the employees who work directly under them. They
 * technically co-supervise all employees under them."
 *
 * 🔥 THE RULE IT BENDS, stated exactly. A supervisor's report set is normally the
 * employees whose `ns_supervisor_id` is theirs — Gate-2 decision #1, 2026-08-13, and
 * the default the whole approval path is built on. A peer group widens that set to the
 * UNION of the groups' members' own report sets, and nothing else.
 *
 * SYMMETRIC BY CONSTRUCTION. Membership is a set, not a pair of grants, so there is no
 * way to express "Cody sees Grayson's team but not the reverse". A one-way version of
 * this is how a stand-in arrangement quietly turns into a privilege escalation that
 * nobody can see the direction of.
 *
 * IT GRANTS NOTHING ELSE. Not admin, not the supervisor picker, not posting. A peer is
 * a supervisor of more people; they are not a different KIND of user.
 */
/**
 * The smallest group that does anything.
 *
 * A group of one is not co-supervision — it widens nobody's view — and letting one be
 * saved produces a screen full of arrangements that look active and are inert.
 */
export const MIN_PEER_GROUP_MEMBERS = 2;
//# sourceMappingURL=supervisor-peer.js.map